import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  isAuthenticated(): boolean {
    if (this.isAdmin() && this.isTokenExpires()) {
      return true;
    } else {
      return false;
    }
  }

  isTokenExpires(): boolean {
    const expirationDate = this.getIdentity().exp * 1000;
    const dateNow = Date.now();

    return expirationDate > dateNow;
  }

  isAdmin(): boolean {
    return this.getIdentity().rol == 1 ||
      this.getIdentity().rol == 2 ||
      this.getIdentity().rol == 4
      ? true
      : false;
  }

  getIdentity() {
    const local = localStorage.getItem('identity');

    let identity = JSON.parse(local ? local : '');

    if (identity && identity != 'undefined') {
      return identity;
    } else {
      return null;
    }
  }

  getToken() {
    let token = localStorage.getItem('token');

    if (token && token != 'undefined') {
      return token;
    } else {
      return null;
    }
  }

  getRole(): number {
    const user = this.getIdentity();
    return user.rol;
  }

  isUserAllowed(allowedRoles: number[]) {
    if (allowedRoles.length === 0) {
      return true;
    }

    const role = this.getRole();

    return allowedRoles.includes(role);
  }
}
